(function ($) {
  $(function () {
    const $map = $('.js-maps');
    if (!$map.length || typeof google === 'undefined') return;

    const config = window.mapsConfig ?? {};

    // An address without coordinates arrives as null, and Number(null) is 0,
    // which would drop the marker off the coast of Africa.
    const isBlank = (value) =>
      value == null || String(value).trim() === '';
    if (isBlank(config.lat) || isBlank(config.lng)) return;

    const lat = Number(config.lat);
    const lng = Number(config.lng);
    if (Number.isNaN(lat) || Number.isNaN(lng)) return;

    const position = { lat, lng };

    const map = new google.maps.Map($map[0], {
      center: position,
      zoom: 12,
      zoomControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      scaleControl: false,
      fullscreenControl: false,
      panControl: false,
      rotateControl: false,
    });

    new google.maps.Marker({
      position,
      map,
      icon: {
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(config.iconSvg),
        scaledSize: new google.maps.Size(30, 40),
      },
      animation: google.maps.Animation.DROP,
    });
  });
}(jQuery));
